import { mountApplications } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/show.js?vue3';

mountApplications();
